import { AnyAction } from 'redux';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import getCategoryId from 'src/store/design/selector/getCategoryId';
import getPrice from 'src/store/price/selector/getPrice';
import fetchPricesOperation from 'src/store/price/operation/fetchPricesOperation';

// Generic category type that works with both old and new APIs
type ClipArtCategoryLike = {
  clipArts?: Array<{ productId: number }> | null;
  subCategories?: ClipArtCategoryLike[] | null;
};

const collectProductIdsFromClipartCategory = (clipArtCategory: ClipArtCategoryLike): number[] => {
  const productIds = clipArtCategory.clipArts?.map((clipArt) => clipArt.productId) || [];
  const productIdsFromSubCategories = clipArtCategory.subCategories?.map((category) => collectProductIdsFromClipartCategory(category)) || [];
  return [...productIds, ...productIdsFromSubCategories.flat()];
};

const fetchClipArtsPrice = async (clipArtCategory: ClipArtCategoryLike, categoryId: number, dispatch: any, store: Store) => {
  const clipArtIds = [...new Set(collectProductIdsFromClipartCategory(clipArtCategory))];
  const missingPricesProductIds: number[] = [];
  clipArtIds.forEach((productId) => {
    if (!getPrice(store, categoryId, productId, 1)) {
      missingPricesProductIds.push(productId);
    }
  });
  if (missingPricesProductIds.length) {
    await dispatch(fetchPricesOperation(categoryId, missingPricesProductIds));
  }
};

const fetchClipArtsPriceOperation = (clipArtCategory: ClipArtCategoryLike) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const categoryId = getCategoryId(getState());
  await fetchClipArtsPrice(clipArtCategory, categoryId || 1, dispatch, getState());
};

export default fetchClipArtsPriceOperation;
